<template>
  <div class="cards-grid">
    <div
      v-for="(value, index) in cards"
      :key="index"
      class="item"
      :id="`card-item-${elementId}`"
      :style="{
        height: iHeight,
        width: iWidth,
      }"
      :class="{ active: selectedElementIndex == index }"
      :ref="`cardRef-${index}`"
    >
      <div class="card-tools" v-show="!viewOnly">
        <i
          v-if="selectedElementIndex == index"
          class="fa fa-check fa-lg"
          style="font-size: 16px; padding-right: 2px"
          @click="toggleSelectedElement(index)"
        ></i>
        <i v-else class="fas fa-edit" @click="toggleSelectedElement(index)"></i>
        <i
          v-if="selectedElementIndex == index && index !== lastAddedItemIndex"
          class="fas fa-times"
          @click="discardChanges(index)"
        ></i>
        <i v-else class="fas fa-trash-alt" @click="removeItem(index)"></i>
      </div>

      <div
        class="row"
        v-for="(val, key, idx) in sortKeysAsSchemaOrder(cards[index])"
        :key="idx"
      >
        <!-- Not editable -->
        <span
          v-if="
            selectedElementIndex != index &&
            getCardInfo(key, 'type') === 'formatted_number'
          "
          class="d-flex flex-wrap flex-row"
          >{{ getCardInfo(key, 'label') }} :
          <NumberComponent
            class="d-inline-block"
            :passedNumberValue="cards[index][key]"
            :decimalValuesCount="getCardInfo(key, 'settings')?.toFixed ?? 2"
            :showAsFixedNumber="true"
            :formatNumber="getFormatNumber(key)"
            :elementName="getCardInfo(key, 'name')"
            :isCardElem="true"
        /></span>

        <div
          v-else-if="
            selectedElementIndex != index &&
            (getCardInfo(key, 'type') === 'date' ||
              getCardInfo(key, 'type') === 'datetime-local')
          "
        >
          <span>{{ getCardInfo(key, 'label') }}&nbsp;: </span>
          <span class="word-break">{{ getFormatedDate(val, key) }}</span>
        </div>

        <div v-else-if="selectedElementIndex != index" class="card-wrapper">
          <span>{{ getCardInfo(key, 'label') }}&nbsp;: </span>
          <span class="word-break">{{ val }}</span>
        </div>

        <!-- Editable -->
        <div class="form-item-wrap">
          <span v-show="selectedElementIndex == index"
            >{{ getCardInfo(key, 'label') }} :</span
          >
          <input
            v-if="
              selectedElementIndex == index &&
              generalElements.includes(getCardInfo(key, 'type'))
            "
            :type="getCardInfo(key, 'type')"
            :name="`${getCardInfo(key, 'name')}_${index}`"
            :placeholder="getCardInfo(key, 'placeholder')"
            :disabled="isInputDisabled(key)"
            :required="isInputRequired(key, false)"
            v-model="cards[index][key]"
            :step="getSteps(key)"
            @input="handleInputValidation"
            @invalid="handleInputValidation"
          />
          <div
            v-if="
              selectedElementIndex == index &&
              choicesElement.includes(getCardInfo(key, 'type'))
            "
            class="multiple-choice-inputs"
          >
            <input
              v-if="checkboxValidationRequired(key)"
              type="text"
              :required="true"
              :value="checkboxValidation(key, index)"
              class="checkBox-validation"
              @invalid="setCustomValidity($event, key, index)"
            />
            <div
              class="multiple-choice-inputs-wrap"
              v-for="(options, i) in getCardInfo(key, 'options')"
              :key="`${options['label']}_${i}_${idx}_${index}`"
            >
              <input
                :type="getCardInfo(key, 'type')"
                :name="`${getCardInfo(key, 'name')}_${index}`"
                :value="options['label']"
                :id="getInputID(options['label'], key, index)"
                :disabled="isInputDisabled(key)"
                :required="isInputRequired(key, true, cards[index][key])"
                v-model="cards[index][key]"
              />
              <label :for="getInputID(options['label'], key, index)">{{
                options['label']
              }}</label>
            </div>
          </div>
          <NumberComponent
            v-if="
              selectedElementIndex == index &&
              getCardInfo(key, 'type') === 'formatted_number'
            "
            :passedNumberValue="cards[index][key]"
            :editableComponent="true"
            :requiredInput="
              getCardInfo(key, 'attributes').hasOwnProperty('required') &&
              getCardInfo(key, 'attributes')['required']
            "
            @onNumberInputChange="
              onNumberComponentInputChange($event, index, key)
            "
            :decimalValuesCount="getCardInfo(key, 'settings')?.toFixed ?? 2"
            :elementName="getCardInfo(key, 'name')"
            :componentPlaceholder="getCardInfo(key, 'placeholder') ?? '0'"
            :isCardElem="true"
          />
        </div>
      </div>
    </div>
    <div
      class="add-button-wrapper"
      v-if="!viewOnly && selectedElementIndex === null"
    >
      <div class="add-button" @click="addItem">+</div>
    </div>
  </div>
</template>

<script>
import {
  convertDateToCETDate,
  showInputInvalidCustomMessage,
} from '../../utils/helpers';
import NumberComponent from './NumberComponent.vue';
import { getCheckboxMinMax } from '@/utils/helpers';
export default {
  name: 'cards-component',
  data() {
    return {
      selectedElementIndex: null,
      generalElements: ['email', 'datetime-local', 'date', 'number', 'text'],
      choicesElement: ['checkbox', 'radio'],
      selectedElementDefaultValues: null,
      lastAddedItemIndex: null,
    };
  },
  props: [
    'schema',
    'cards',
    'itemWidth',
    'itemHeight',
    'viewOnly',
    'isAddButtonDisable',
    'elementId',
  ],
  methods: {
    getInputID(label, key, index) {
      return `${label.replace(' ', '-').toLowerCase()}_${this.getCardInfo(
        key,
        'name'
      )}_${index}`;
    },
    isInputRequired(key, isChoiceElement, cardElement) {
      if (isChoiceElement) {
        return this.getCardInfo(key, 'attributes').hasOwnProperty('required') &&
          this.getCardInfo(key, 'attributes')['required']
          ? this.getCardInfo(key, 'type') === 'checkbox'
            ? this.isCheckboxRequired(cardElement)
            : true
          : false;
      } else {
        return (
          this.getCardInfo(key, 'attributes').hasOwnProperty('required') &&
          this.getCardInfo(key, 'attributes')['required']
        );
      }
    },
    isInputDisabled(key) {
      return (
        this.getCardInfo(key, 'attributes').hasOwnProperty('disabled') &&
        this.getCardInfo(key, 'attributes')['disabled']
      );
    },
    onNumberComponentInputChange(newValue, index, key) {
      this.cards[index][key] = newValue;
    },
    isCheckboxRequired(cardCheckedArray) {
      let minCheckedLength = 1;
      return cardCheckedArray.length < minCheckedLength;
    },
    discardChanges(index) {
      this.cards[index] = this.selectedElementDefaultValues
        ? this.selectedElementDefaultValues
        : JSON.parse(JSON.stringify(this.getCardDefaultObject));
      this.selectedElementIndex = null;
    },

    getCardInfo(key, prop) {
      return this.getCardObject[key] ? this.getCardObject[key][prop] : null;
    },
    sortKeysAsSchemaOrder(card) {
      return JSON.parse(JSON.stringify(card, this.keyOrderFromSchema));
    },
    getSteps(key) {
      if (this.getCardInfo(key, 'type') === 'number') {
        const attributes = this.getCardInfo(key, 'attributes');
        if (attributes && attributes.hasOwnProperty('step')) {
          return attributes.step;
        } else {
          return 0;
        }
      } else {
        return null;
      }
    },
    addItem() {
      if (this.isAddButtonDisable !== undefined && this.isAddButtonDisable) {
        return;
      }
      this.cards.splice(
        this.cards.length,
        1,
        JSON.parse(JSON.stringify(this.getCardDefaultObject))
      );
      this.toggleSelectedElement(this.cards.length - 1);
      this.lastAddedItemIndex = this.cards.length - 1;
    },
    removeItem(index) {
      if (this.selectedElementIndex === index) {
        this.selectedElementIndex = null;
      } else if (index < this.selectedElementIndex) {
        this.selectedElementIndex = this.selectedElementIndex - 1;
      }

      this.cards.splice(index, 1);
      if (this.lastAddedItemIndex != null)
        this.lastAddedItemIndex = this.lastAddedItemIndex - 1;
    },
    toggleSelectedElement(i) {
      const cardIndex =
        this.selectedElementIndex == i ? i : this.selectedElementIndex;

      const validate = () => {
        const cardRef = this.$refs['cardRef-' + cardIndex][0];
        const cardInputs = cardRef.getElementsByTagName('input');
        const labelElements = ['radio'];
        let isValid = true;
        for (const formInputs of cardInputs) {
          if (formInputs.type === 'checkbox') {
            const findCheckBox = this.schema.find(
              (item) => `${item.name}_${cardIndex}` === formInputs.name
            );
            const minMaxVal = getCheckboxMinMax(findCheckBox);
            const checked = this.cards[cardIndex][findCheckBox.name].length;
            const label = formInputs.nextElementSibling;
            if (
              (checked < minMaxVal.min || checked > minMaxVal.max) &&
              findCheckBox.attributes.required &&
              !findCheckBox.attributes.disabled
            ) {
              isValid = false;
              label.style.backgroundColor = '#ffaeae';
            } else {
              label.style.backgroundColor = '';
            }
          } else if (!formInputs.checkValidity()) {
            isValid = false;
            if (labelElements.includes(formInputs.type)) {
              const label = formInputs.nextElementSibling;
              if (label) label.style.backgroundColor = '#ffaeae';
            } else {
              formInputs.style.backgroundColor = '#ffaeae';
            }
          } else {
            if (labelElements.includes(formInputs.type)) {
              const label = formInputs.nextElementSibling;
              if (label) label.style.backgroundColor = '';
            } else {
              formInputs.style.backgroundColor = '';
            }
          }
        }
        if (isValid) {
          this.selectedElementIndex = null;
          this.lastAddedItemIndex = null;
        }
        return isValid;
      };

      if (this.selectedElementIndex == i) {
        validate();
      } else {
        const toggleCard = () => {
          this.selectedElementIndex = i;
          this.selectedElementDefaultValues = JSON.parse(
            JSON.stringify(this.cards[i])
          );
        };
        if (this.selectedElementIndex === null) {
          toggleCard();
        } else {
          const isvalidated = validate();
          if (isvalidated) {
            toggleCard();
          }
        }
      }
    },
    getFormatNumber(key) {
      const settings = this.getCardInfo(key, 'settings');
      return {
        thousandseparator: settings?.thSep ?? '.',
        decimalseparator: settings?.decSep ?? ',',
      };
    },
    setCustomValidity(e, key, index) {
      if (this.checkboxValidation(key, index) === '') {
        let minValue = this.getCheckBoxElementMinMax(key).minValue;
        let maxValue = this.getCheckBoxElementMinMax(key).maxValue;
        e.target.setCustomValidity(
          `Es müssen mindestens ${minValue} Kontrollkästchen aktiviert sein, und es können nicht mehr als ${maxValue} Kontrollkästchen aktiviert sein.`
        );
      } else {
        e.target.setCustomValidity('');
      }
    },
    checkboxValidation(key, index) {
      const minValue = this.getCheckBoxElementMinMax(key).minValue;
      const maxValue = this.getCheckBoxElementMinMax(key).maxValue;
      const totalChecked =
        this.cards[index][this.getCardInfo(key, 'name')].length;
      if (totalChecked < minValue || totalChecked > maxValue) {
        return '';
      } else {
        return '90';
      }
    },
    getCheckBoxElementMinMax(key) {
      const minValue =
        this.getCardInfo(key, 'settings').min !== '' &&
        this.getCardInfo(key, 'settings').min !== undefined
          ? this.getCardInfo(key, 'settings').min
          : 1;
      const maxValue =
        this.getCardInfo(key, 'settings').max !== '' &&
        this.getCardInfo(key, 'settings').max !== undefined
          ? this.getCardInfo(key, 'settings').max
          : this.getCardInfo(key, 'options').length;
      return {
        minValue,
        maxValue,
      };
    },
    checkboxValidationRequired(key) {
      return (
        this.getCardInfo(key, 'type') === 'checkbox' &&
        this.getCardInfo(key, 'attributes').required &&
        !this.getCardInfo(key, 'attributes').disabled
      );
    },
    getFormatedDate(date, key) {
      if (this.getCardInfo(key, 'type') === 'date') {
        return convertDateToCETDate(date).format('DD.MM.YYYY');
      } else {
        return convertDateToCETDate(date).format('DD.MM.YYYY HH:mm');
      }
    },
    handleInputValidation(event) {
      showInputInvalidCustomMessage(event);
    },
  },
  computed: {
    iWidth() {
      if (this.itemWidth) return this.itemWidth;
      return 'fit-content';
    },
    iHeight() {
      if (this.itemHeight) return this.itemHeight;
      return 'fit-content';
    },
    keyOrderFromSchema() {
      return this.schema.map((e) => e.name);
    },
    getCardObject() {
      const cardObject = this.schema.reduce((obj, currentObj) => {
        obj[currentObj.name] = currentObj;
        return obj;
      }, {});
      return cardObject;
    },
    getElementsObject() {
      return this.schema.map((el) => ({
        name: el['name'],
        label: el['label'],
        type: el['type'],
      }));
    },
    getCardDefaultObject() {
      let DefaultValueObject = {
        checkbox: [],
        number: null,
        formatted_number: 0,
      };
      return this.schema.reduce((obj, currentObject) => {
        if (
          (currentObject.hasOwnProperty('default') &&
            currentObject['default']) ||
          currentObject.type === 'radio' ||
          currentObject.type === 'checkbox'
        ) {
          obj[currentObject.name] = currentObject['value'];
        } else if (DefaultValueObject[currentObject['type']] !== undefined) {
          if (currentObject.type === 'formatted_number') {
            obj[currentObject.name] = null;
          } else {
            obj[currentObject.name] = DefaultValueObject[currentObject['type']];
          }
        } else {
          obj[currentObject.name] = '';
        }
        return obj;
      }, {});
    },
  },
  watch: {
    schema: {
      handler(schema) {
        if (this.cards && this.cards.length) {
          this.cards.forEach((item, index) => {
            schema.forEach((schemaItem) => {
              if (!item.hasOwnProperty(schemaItem.name)) {
                if (
                  schemaItem.default ||
                  schemaItem.type === 'checkbox' ||
                  schemaItem.type === 'radio'
                ) {
                  item[schemaItem.name] = schemaItem.value;
                } else {
                  item[schemaItem.name] = '';
                }
              }
            });
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  components: { NumberComponent },
};
</script>

<style scoped>
.cards-grid .item {
  display: inline-grid;
  background: #ffffff;
  margin-right: 8px;
  margin-bottom: 15px;
  cursor: pointer !important;
  text-align: center !important;
  border: 1px solid rgb(221, 221, 221) !important;
  background-color: rgb(255, 255, 255) !important;
  outline: none !important;
  font-family: Circular, -apple-system, BlinkMacSystemFont, Roboto,
    'Helvetica Neue', sans-serif !important;
  transition-property: -ms-transform, -webkit-transform, transform,
    background-color, border-color !important;
  transition-duration: 0.15s !important;
  padding: 17px 47px 17px 17px !important;
  border-radius: 19px !important;
  font-size: 15px !important;
  color: var(--brand-color-dark) !important;
  text-align: left !important;
  padding: 25px !important;
}

.cards-grid .item .card-tools {
  text-align: right;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  margin-bottom: 10px;
}

.cards-grid .item .card-tools i {
  margin-left: 5px;
}

.cards-grid .item input {
  margin-left: 3px;
  padding-left: 5px;
  border-radius: 5px;
  border: solid 1px;
  background: rgb(247, 247, 247);
  width: 100%;
}

.cards-grid .item img {
  width: 34px;
  margin-bottom: 39px;
}

.cards-grid .item:hover {
  color: var(--brand-color-dark) !important;
  border-color: var(--bbrand-color-darklue) !important;
}

.cards-grid .item.active {
  background-color: rgb(247, 247, 247) !important;
  border-color: var(--brand-color-dark) !important;
  border: 2px solid !important;
}

.cards-grid .item span {
  word-break: break-all;
  /* white-space: nowrap; */
  /* min-width: 140px; */
}

:root {
  --brand-color-dark: black;
}
.cards-grid ::v-deep .number-input {
  background: rgb(247, 247, 247);
  border: 1px solid;
  height: 30px;
  padding: 0 15px 0 5px;
  border-radius: 5px;
  width: 100%;
}
.cards-grid .form-item-wrap {
  display: flex;
  /* align-items: center; */
  margin-bottom: 15px;
}
.cards-grid .multiple-choice-inputs {
  width: 100%;
  display: flex;
  gap: 10px;
  position: relative;
  flex-wrap: wrap;
}

.cards-grid .item.active ::v-deep .number-component {
  width: 100%;
}
.cards-grid .item ::v-deep .number-component {
  white-space: normal;
  word-break: break-all;
}

.cards-grid .multiple-choice-inputs .multiple-choice-inputs-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.cards-grid .multiple-choice-inputs .multiple-choice-inputs-wrap input {
  width: 18px !important;
  margin-right: 7px;
}
.cards-grid .word-break {
  word-break: break-all;
  display: inline-block;
  white-space: normal !important;
  flex-grow: 1;
}
.cards-grid .card-wrapper {
  display: flex;
  align-items: start;
  flex-wrap: wrap;
}
.cards-grid .checkBox-validation {
  width: 0px !important;
  height: 0px;
  margin: 0px !important;
  padding: 0px !important;
  position: absolute;
  bottom: 2px;
  border: 1px solid transparent !important;
}
</style>
